<template>
  <div class="stars">
    <span
      v-for="n in 5"
      :key="n"
      :class="['star', modelValue >= n ? 'filled' : '']"
      @click="update(n)"
      @mouseover="hover = n"
      @mouseleave="hover = 0"
    >{{ hover >= n || modelValue >= n ? '★' : '☆' }}</span>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const props = defineProps<{ modelValue: number }>()
const emit = defineEmits(['update:modelValue'])
const hover = ref(0)
function update(n: number) {
  emit('update:modelValue', n)
}
</script>

<style scoped>
.stars {
  font-size: 2.1rem;
  color: #ffd600;
  cursor: pointer;
  user-select: none;
  display: flex;
  gap: 2px;
}
.star {
  color: #ddd;
  transition: color .2s;
}
.star.filled {
  color: #ffd600;
  text-shadow: 0 2px 8px #ffecb3;
}
</style>
